import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const citySearch = createAsyncThunk('citySearch', async (data) => {

    try {
        const res = await axios({

            method: 'get',
            url: process.env.REACT_APP_API_URL + `city_search`,
            params: {
                'search': data?.city
            },
            headers: { "Content-Type": "application/json", "Authorization": `Bearer ${localStorage.getItem("token")}` }

        })
        return res
    } catch (error) {
        return error.response
    }
})

const citySearchSlice = createSlice({
    name: 'citySearch',
    initialState: {
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(citySearch.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                state.data = action.payload.data.data;
            } else if (action?.payload?.status === 401) {
                state.data = [];
                localStorage.clear();
                action?.meta?.arg?.navigate('../login')
            } else {
                state.data = [];
            }
        });
        builder.addCase(citySearch.rejected, (state, action) => {
            // console.log('reject', action)
        })
    }
})

export default citySearchSlice.reducer; 